import request from "../libs/request";
import { SmartOfficeEncryption } from "../types/smartOffice";

const baseUrl = "smart-office";

// 스마트 오피스 연동용 enc 값 가져오기
export const getSmartOfficeEncryptionInfo = () =>
  request.get<SmartOfficeEncryption>(baseUrl + "/member");

// 스마트 오피스 도메인
export const getSmartOfficeDomainInfo = () =>
  request.get<string>(baseUrl + "/domain");
